import React from 'react'
import {
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share'

export const ShareButtons = ({ url, title }) => {
  return (
    <div className="blogSidebar__section">
      <h2>Share Article</h2>

      <ul className="socialLinks">
        <li>
          <TwitterShareButton url={url} title={title}>
            <TwitterIcon size={32} borderRadius={8} />
          </TwitterShareButton>
        </li>
        <li className="ml-2">
          <LinkedinShareButton url={url} title={title}>
            <LinkedinIcon size={32} borderRadius={8} />
          </LinkedinShareButton>
        </li>
      </ul>
    </div>
  )
}
